import { supabase } from '../lib/supabase';

export const galleryService = {
  async createGallery(galleryData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('galleries')?.insert({
          creator_id: user?.id,
          gallery_name: galleryData?.galleryName,
          description: galleryData?.description,
          gallery_type: galleryData?.galleryType,
          template: galleryData?.template,
          client_name: galleryData?.clientName,
          client_email: galleryData?.clientEmail,
          client_phone: galleryData?.clientPhone,
          require_media_metadata: galleryData?.requireMediaMetadata ?? true,
          download_enabled: galleryData?.downloadEnabled ?? true,
          is_published: galleryData?.isPublished ?? false,
          drive_high_res_folder_id: galleryData?.driveHighResFolderId,
          drive_high_res_folder_name: galleryData?.driveHighResFolderName,
          drive_compressed_folder_id: galleryData?.driveCompressedFolderId,
          drive_compressed_folder_name: galleryData?.driveCompressedFolderName,
          auto_sync: galleryData?.autoSync ?? true
        })?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error creating gallery:', error);
      throw error;
    }
  },

  async updateGallery(galleryId, updates) {
    try {
      const { data, error } = await supabase?.from('galleries')?.update({
          gallery_name: updates?.galleryName,
          description: updates?.description,
          gallery_type: updates?.galleryType,
          template: updates?.template,
          client_name: updates?.clientName,
          client_email: updates?.clientEmail,
          client_phone: updates?.clientPhone,
          require_media_metadata: updates?.requireMediaMetadata,
          download_enabled: updates?.downloadEnabled,
          is_published: updates?.isPublished,
          cover_photo_id: updates?.coverPhotoId,
          show_media_info: updates?.showMediaInfo,
          drive_high_res_folder_id: updates?.driveHighResFolderId,
          drive_high_res_folder_name: updates?.driveHighResFolderName,
          drive_compressed_folder_id: updates?.driveCompressedFolderId,
          drive_compressed_folder_name: updates?.driveCompressedFolderName,
          auto_sync: updates?.autoSync,
          last_sync_at: updates?.lastSyncAt
        })?.eq('id', galleryId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating gallery:', error);
      throw error;
    }
  },

  async setCoverPhoto(galleryId, mediaId) {
    try {
      const { data, error } = await supabase?.from('galleries')?.update({ cover_photo_id: mediaId })?.eq('id', galleryId)?.select()?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error setting cover photo:', error);
      throw error;
    }
  },

  async getGalleryById(galleryId) {
    try {
      const { data, error } = await supabase?.from('galleries')?.select(`
          *,
          user_profiles!galleries_creator_id_fkey(full_name, avatar_url),
          media!galleries_cover_photo_id_fkey(file_url, alt_text)
        `)?.eq('id', galleryId)?.single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching gallery:', error);
      throw error;
    }
  },

  async getUserGalleries() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('galleries')?.select('*')?.eq('creator_id', user?.id)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching user galleries:', error);
      throw error;
    }
  },

  async getPublishedGalleries() {
    try {
      const { data, error } = await supabase?.from('galleries')?.select('*')?.eq('is_published', true)?.order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error fetching published galleries:', error);
      throw error;
    }
  }
};
